<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :show.sync="show">
        

        <p style="color:blue;">Resolusi gambar sebaiknya 2:1 | contoh 600x300 / 1568x784</p>
        <b-form-file size="sm" v-model="form.file" class="mt-3" plain></b-form-file>

        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>

        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="upload()"  variant="outline" color="info">Upload</CButton>
        
      </template>
      <img v-if="key === 'home_bgimage'"  class="mt-3" v-bind:src="getHomeImage()" width='300px'/>
      <img v-if="key === 'event_bgimage'" class="mt-3" v-bind:src="getEventImage()" width='300px'/>
      <img v-if="key === 'location_bgimage'" class="mt-3" v-bind:src="getLocationImage()" width='300px'/>
      <img v-if="key === 'profile_bgimage'" class="mt-3" v-bind:src="getProfileImage()" width='300px'/>
      <img v-if="key === 'icarerequest_bgimage'" class="mt-3" v-bind:src="getIcareImage()" width='300px'/>
    </CModal>
  </form>
</template>

<script>
import moment from 'moment';

import EventBus from '@/eventBus';

import files from '@/services/files'

export default {
name: 'modalphoto',

  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      form:{
        file: '',
      },
      key:''
    }
  },
  mounted(){
    
  },

  
  created () {
    var self = this;
    EventBus.$on('OPEN_MODAL_PHOTO', (params) => {
      if(params.data){
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.key = params.data;
      }else{

      }
    });
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    upload(){
        let formData = new FormData();
        formData.append('file', this.form.file);
        
        this.show = false;
        files.uploadGlobalImage(this.key,formData)
        .then(res => {
            EventBus.$emit('TABLE_UPDATE', true)
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
        console.log('get photo')
    },

    getHomeImage(){
        return process.env.VUE_APP_URL + "/getfile/global/home_bgimage.jpg";
    },
    getEventImage(){
        return process.env.VUE_APP_URL + "/getfile/global/event_bgimage.jpg";
    },
    getLocationImage(){
        return process.env.VUE_APP_URL + "/getfile/global/location_bgimage.jpg";
    },
    getProfileImage(){
        return process.env.VUE_APP_URL + "/getfile/global/profile_bgimage.jpg";
    },
    getIcareImage(){
        return process.env.VUE_APP_URL + "/getfile/global/icarerequest_bgimage.jpg";
    }

  }
}
</script>

<style>
.center {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>